module.exports = __webpack_public_path__ + "img/fundo_footer.e86a59c2.jpg";